// Static mapping between statistics routes and required permission keys.
const STATISTICS_ROUTE_PERMISSIONS = {
  '/statistics/finances': 'salonFinanceStats', // 👉 Finanse salonu
  '/statistics/employeesActivity': 'employeeActivitiesStats', // 👉 Aktywności
  '/statistics/employeesCommissions': 'employeeFinanceStats', // 👉 Finanse pracowników
  '/statistics/services': 'servicesStats', // 👉 Usługi
  '/statistics/servicesCategories': 'servicesStats', // 👉 Usługi - kategorie
  '/statistics/servicesEmployee': 'servicesStats', // 👉 Usługi - pracownicy
  '/statistics/workTime': 'workTimeStats', // 👉 Czas pracy
  '/statistics/clients': 'clientStats', // 👉 Klienci
  '/statistics/store': 'storeStats', // 👉 Magazyn
  '/statistics/checkout': 'checkoutStats', // 👉 Raport z kasy
  '/statistics/sales': 'productSalesStats', // 👉 Sprzedane produkty
  '/statistics/visits': 'visitsStats', // 👉 Lista wizyt
  '/statistics/dac7': 'dac7Stats', // 👉 DAC7
}

// Resolves permission for both exact statistics routes and dynamic sub-routes.
const resolveStatisticsPermission = path => {
  let requiredPermission = STATISTICS_ROUTE_PERMISSIONS[path]

  // 👉 Finanse pracowników
  if (!requiredPermission && path.startsWith('/statistics/employeesCommissions/')) {
    requiredPermission = 'employeeFinanceStats'
  }
  // 👉 Usługi - wybrany pracownik
  if (!requiredPermission && path.startsWith('/statistics/servicesEmployee/')) {
    requiredPermission = 'servicesStats'
  }
  // 👉 DAC7 - Miesąc
  if (!requiredPermission && path.startsWith('/statistics/dac7/')) {
    requiredPermission = 'dac7Stats'
  }

  return requiredPermission
}

// Enforces "self" access mode for employees commissions statistics view.
// 👉 (Finanse pracowników)
const handleEmployeesCommissionsGuard = ({ to, isSelfMode, userStore }) => {
  const isEmployeesCommissionsRoute = to.path === '/statistics/employeesCommissions'

  if (!isSelfMode || !isEmployeesCommissionsRoute) return true

  const currentUserEkey = String(userStore.currentUser?.ekey || '')
  const targetEkey = String(to.params.ekey || '')

  if (!currentUserEkey) return '/statistics'

  const shouldRedirectToSelf = !targetEkey || targetEkey !== currentUserEkey

  if (shouldRedirectToSelf) {
    return `/statistics/employeesCommissions/${currentUserEkey}`
  }

  return true
}

// Validates access to employee service statistics and redirects invalid targets.
// 👉 Usługi
const handleServicesEmployeeGuard = ({ to, isSelfMode, userStore, calendarStore }) => {
  const isServicesEmployeeRoute = to.path.startsWith('/statistics/servicesEmployee')

  if (!isServicesEmployeeRoute) return true

  const targetId = String(to.params.id || '')
  const currentUserId = String(userStore.currentUser?.id || '')

  const allowedEmployeeIds = new Set(
    (calendarStore.employeesCalendars || []).map(e => String(e.employeeId ?? e.id)),
  )

  const hasEmployeeList = Array.isArray(calendarStore.employeesCalendars) && calendarStore.employeesCalendars.length > 0
  const isTargetKnown = !!targetId && allowedEmployeeIds.has(targetId)

  if (isSelfMode) {
    if (!currentUserId) return '/statistics/services'

    if (targetId !== currentUserId) {
      return `/statistics/servicesEmployee/${currentUserId}`
    }
  }

  if (hasEmployeeList && !isTargetKnown) return '/statistics/services'

  return true
}

export {
  STATISTICS_ROUTE_PERMISSIONS,
  resolveStatisticsPermission,
  handleEmployeesCommissionsGuard,
  handleServicesEmployeeGuard,
}
